import ROUTES from 'utils/constants/routes.json';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CursivePinkText from './CursivePinkText';
import BoldPinkUppercasedText from './BoldPinkUppercasedText';

const FreeResultInfo = () => {
    const { t } = useTranslation('translation');

    return (
        <span>
            {t('in_order_to_free_download')}
            &nbsp;
            <CursivePinkText>{t('result_1')}</CursivePinkText>
            &nbsp;
            {t('head_to')}
            &nbsp;
            <Link to={ROUTES.login_result}>
                <BoldPinkUppercasedText>{t('patient_portal')}</BoldPinkUppercasedText>
            </Link>
            .
        </span>
    );
};
export default FreeResultInfo;
